import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GET_AGENDA_SOLUTION_FOLLOWER,
  LOGIN_DONE_SUGGESTS,
  LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC,
  LOGIN_NOT_SUGGESTS,
} from 'manager/http-constants';
import { forkJoin, Observable } from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import { CONSTANT, LOADING_KEY } from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-c401',
  templateUrl: './c401.component.html',
  styleUrls: ['./c401.component.scss', '../platform.component.scss'],
})

/**
 * 提案登録(C401)
 * 提案登録確認(C402)
 */
export class C401Component extends PlatformComponent {
  // 画面.入力フォーム
  c401InputForm: FormGroup = this.formBuilder.group({
    // 提案/依頼タイトル
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'suggest',
          'title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 提案/依頼詳細内容
    detail: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'suggest',
          'detail',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 導入事例・実績等
    case: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'suggest',
          'case',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 質問事項
    question: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'suggest',
          'question',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 参考情報
    reference: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'suggest',
          'reference',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
  });

  // 課題IDを格納
  agendaId: string = this.route.snapshot.queryParams.agenda_id;

  // 提案IDを格納
  suggestId: string = this.route.snapshot.queryParams.suggest_id;

  // 課題・ソリューション詳細格納先
  detailTask: any;

  // 確認画面表示フラグ(true=提案登録確認(C402),false=提案登録(C401))
  confirmationFlag: boolean = false;

  //main suggest checkbox
  mainCB:boolean = false;

  //notify owner status
  isNotifyOwner:boolean = true;

  //list selected member to notify
  listChosed :any[]=[];

  //list followed member
  listFollow:any[] = [];

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private location: Location,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを提案登録(C401)に変更する
    this.router.navigate(['pages/platform/c401/' + this.inputType], {
      queryParams: {
        screenId: 'c401',
        agenda_id: this.agendaId,
        suggest_id: this.suggestId,
      },
    });
  }

  async ngOnInit(): Promise<void> {
    await this.getUserLogin();
    // 課題一覧を取得
    this.getDetailTask();

    // 編集初期表示
    this.setEditInitialData();
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });

  }

  /**
   * 課題・ソリューション詳細を取得
   */
  private getDetailTask(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

    // 課題・ソリューション詳細を取得
    this.dbOperationService
    .getNoTemplateDisplayData(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC, this.agendaId)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // 前画面へ戻る
          this.location.back();
        } else {
          // 課題・ソリューション詳細を格納
          this.detailTask = response.body[0];
          if(this.detailTask.delete_datetime){
            // 異常メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
                position: TOAST.BOTTOM_RIGHT,
                life: 60000,
              })
            );
            this.loginService.logout(MESSAGE_CODE.N90001);
            return;
          }
          //get list follower
          if(this.detailTask.flag_batch_suggest == 1){
            this.dbOperationService
          .getNoTemplateDisplayData(GET_AGENDA_SOLUTION_FOLLOWER, this.agendaId)
          .subscribe((response) => {
            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadSleepEnd(0.3, GET_AGENDA_SOLUTION_FOLLOWER);

            if (this.commonService.checkNoneResponse(response)) {
              if (response.body?.length<=0) {
                // 警告メッセージ
                this.messageData.toastMessage(
                  new ToastMessageData({
                    severity: TOAST.WARN,
                    summary: this.commonService.msg(MESSAGE_CODE.E00003),
                    detail: this.commonService.msg(MESSAGE_CODE.E00026),
                  })
                );
              }
              this.listFollow = [];
              this.setInitStateCheckNotice();

              this.loadingState.loadEnd();
            } else {
              if(response.body.Message == 'No Follower'){
                this.setInitStateCheckNotice();
                this.loadingState.loadEnd();
              }else{
                this.listFollow = response.body;
                for (let index = 0; index < this.listFollow.length; index++) {
                  this.listFollow[index]['checked'] = true;
                }
                this.listChosed = this.listFollow.filter(item => item.checked == true);
                this.setInitStateCheckNotice();
                this.loadingState.loadEnd();
              }

            }
          });
          }
        }
      });
  }

  /**
   * set initial state of checkbox notice all follower: checked if there is follower, unchecked if no follower
   */
  setInitStateCheckNotice(){
    if (this.listFollow.length <= 0) {
      this.mainCB = false;
    }else{
      this.mainCB = true;
    }
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.EDIT == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOGIN_NOT_SUGGESTS);

    // 提案詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(LOGIN_NOT_SUGGESTS, this.suggestId)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        if(!this.decisionPerspective(response.body[0].member_id)
          && !this.decisionSecretariat()
        ){
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        if (response.body[0].agenda_id != this.agendaId || response.body[0].suggest_id != this.suggestId){
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.c401InputForm,
          response.body[0]
        );

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_SUGGESTS);
      });
  }

  /**
   * 提案登録(C401)を表示する
   */
  public moveC401(): void {
    // 提案登録(C401)へ遷移
    this.router.navigate(['pages/platform/c401/' + this.inputType], {
      queryParams: { screenId: 'c401', agenda_id: this.agendaId },
    });

    // 提案登録(C401)を表示する
    this.confirmationFlag = false;
  }

  /**
   * 提案登録確認(C402)を表示する
   */
  public moveC402(): void {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

  //get list selected suggest
  this.listChosed = this.listFollow.filter(item => item.checked == true);

  /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    let task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        'suggest',
        this.c401InputForm.value
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 提案登録確認(C402)へ遷移
      this.router.navigate(['pages/platform/c401/' + this.inputType], {
        queryParams: { screenId: 'c402', agenda_id: this.agendaId },
      });

      // 提案登録確認(C402)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 提案登録完了(C403)を表示する
   */
  public moveC403(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let c401InputForm: any = JSON.parse(
      JSON.stringify(this.c401InputForm.value)
    );

    // 会員ID
    c401InputForm.member_id = this.getLoginMemberId();

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      //set list suggest
      let stringFollow: string = '';
      if(this.isNotifyOwner){
        stringFollow = this.agendaId;

      }
      for (let index = 0; index < this.listChosed.length; index++) {
        const element = this.listChosed[index];
          stringFollow = stringFollow + ( stringFollow.length > 0 ? ',':'' ) + element.agenda_id_duplicate
      }
      // 課題・ソリューションID
      c401InputForm.agenda_id = stringFollow;

      // 新規登録の場合

      // 提案登録を実施
      this.dbOperationService
        .insertData(LOGIN_DONE_SUGGESTS, c401InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合
            if (1 == this.detailTask.agenda_kbn.id) {
              sessionStorage.setItem('suggestOrRequest', 'suggest')
            } else {
              sessionStorage.setItem('suggestOrRequest', 'request')
            }

            // 提案登録完了(C403)へ遷移
            this.router.navigate(['pages/platform/c403']);
          } else if (API_RESPONSE.FAIL == response.body.Message) {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 提案登録(C401)を表示する
            this.confirmationFlag = false;
          } else {
            // 提案上限の場合

            // 提案上限メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: response.body.Message
              })
            );

            // 提案登録(C401)を表示する
            this.confirmationFlag = false;
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      c401InputForm.agenda_id = this.agendaId;
      // 編集の場合

      // 提案更新を実施
      this.dbOperationService
        .updateData(LOGIN_DONE_SUGGESTS, this.suggestId, c401InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合
            if (1 == this.detailTask.agenda_kbn.id) {
              sessionStorage.setItem('suggestOrRequest', 'suggest')
            } else {
              sessionStorage.setItem('suggestOrRequest', 'request')
            }

            // 提案登録完了(C403)へ遷移
            this.router.navigate(['pages/platform/c403']);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 提案登録(C401)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }

  /**
   * select/de-select all suggest depends on main checkbox status
   * @param event event onchange checkbox main
   */
  checkAllFollowed(event){
    for (let index = 0; index < this.listFollow.length; index++) {
      this.listFollow[index].checked = event.checked;
    }
      this.listChosed = this.listFollow.filter(item => item.checked == true);
  }

  /**
   * check if all suggest is selected
   */
  isAllChecked(){
    this.listChosed = this.listFollow.filter(item => item.checked == true);
    //get list selected suggest
    const result = this.listFollow.filter(item => item.checked == false);
    this.mainCB = result.length == 0;
  }
  getmaxCount(){
    return this.isNotifyOwner?1999:2000;
  }
}
